import React, { Component } from 'react'
import { NavLink } from 'react-router-dom';
import { Button, Form, FormGroup, Label, Input, Card, Row, Alert } from 'reactstrap';
import axios from "axios";
export default class Login extends Component {
    state = {
        email: "",
        password: "",
        error: "",
        errorB: false
    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }
    submit = (e) => {
        this.setState({errorB:false});
        e.preventDefault();

        const user = {
            "email": this.state.email,
            "password": this.state.password
        }
        console.log(user)
        axios.post("https://azure.ratemycourse.review/login/",
            user)
            .then(res => {
                if(res.data.message){
                    this.setError(res.data.message);
                }
                else{
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('home', res.data.default);
                    this.props.history.push("/group/"+res.data.default);
                }
                
            })
    }
    setError = (message) => {
        this.setState({ error: message, errorB: true })
    }
    componentDidMount() {
        if (localStorage.getItem('token') && localStorage.getItem('home')) {
            this.props.history.push("/group/"+localStorage.getItem('home'));
        }
    }
    render() {
        return (
            <div className="jumbotron d-flex align-items-center min-vh-100">
                <div className="container text-center">
                    <h1 className="text-center display-3">Void</h1>
                    {this.state.errorB && <Alert color="danger">
                        {this.state.error}
                    </Alert>}
                    <Row className="justify-content-center">
                        <Card className="w-50">
                            <Form className="p-5" onSubmit={(e) => this.submit(e)}>
                                <FormGroup>
                                    <Label for="logEmail">Email</Label>
                                    <Input
                                        type="email"
                                        name="email"
                                        id="logEmail"
                                        placeholder="ex: rob@gmail.com"
                                        value={this.state.email}
                                        onChange={this.handleChange}
                                        required />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="logPassword">Password</Label>
                                    <Input
                                        type="password"
                                        name="password"
                                        id="logPassword"
                                        value={this.state.password}
                                        onChange={this.handleChange}
                                        required />
                                </FormGroup>

                                <div className="text-center">
                                    <p>Need a new account? <NavLink to="/signup">Sign Up</NavLink></p>
                                    <Button type="submit" color="dark" >Log in</Button>
                                </div>
                            </Form>
                        </Card>
                    </Row>
                </div>
            </div>
        )
    }
}
